import React, { useState } from 'react'

import PropTypes from 'prop-types'

import Countdown from './CountDown'

function CountdownTimer({ targetDate }) {
  const [timerActive, setTimerActive] = useState(true)

  const handleCountdownFinish = () => {
    setTimerActive(false)
  }

  return (
    <div className="countdown-timer">
      {timerActive ? (
        <Countdown
          targetDate={new Date(targetDate)}
          format={{
            day: true, hour: true, minute: true,
          }}
          leadingZero
          onFinished={handleCountdownFinish}
          showLabels
        />
      ) : (
        <div>00 : 00 : 00 : 00</div>
      )}
    </div>
  )
}


CountdownTimer.propTypes = {
  targetDate: PropTypes.number.isRequired,
}

export default CountdownTimer
